function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import styled from "styled-components";
import { space, color } from "styled-system";
var Svg = styled("svg")({
  flex: "none"
}, space, color);
var SvgInk = React.forwardRef(function (props, ref) {
  return React.createElement(Svg, _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "currentcolor",
    height: props.size,
    width: props.size,
    ref: ref
  }), React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    fill: "inherit"
  }), React.createElement("path", {
    d: "M11.145 8.645a.493.493 0 01.587.284c.23.526.437 1.069.675 1.594.143.316.628.357.818.066.318-.527.572-1.086.882-1.62.254-.332.715-.17 1.064-.202.365-.024.635.437.428.753-1 1.87-2.008 3.732-3.009 5.602-.167.34-.714.34-.865-.016-.223-.543-.398-1.11-.612-1.652-.128-.356-.675-.412-.857-.072-.31.558-.58 1.141-.89 1.691-.15.251-.469.21-.715.21-.238-.015-.524.058-.706-.145a.522.522 0 01-.072-.631c.937-1.774 1.89-3.554 2.827-5.343.111-.203.207-.454.445-.518zm-3.272.138c.278-.016.556-.016.834 0 .31.033.508.43.357.713-.93 1.756-1.866 3.505-2.795 5.253-.112.195-.199.454-.437.518-.278.041-.563.017-.842.017-.34.016-.627-.43-.42-.729.969-1.813 1.937-3.635 2.906-5.456.08-.154.214-.307.397-.316zm9.855.016c.301-.09.62-.024.929-.049.238.009.54-.04.715.17.214.22.15.632-.12.77-.548.348-1.088.72-1.643 1.06-.35.243-.866-.17-.715-.575.135-.324.325-.622.477-.939.087-.162.166-.372.357-.437zm-2.629 4.841c.159-.097.358-.064.508.017.421.21.842.437 1.271.64.183.08.373.234.381.452.032.292-.215.575-.5.551-.611 0-1.223.007-1.827 0-.301 0-.54-.356-.428-.647.079-.211.198-.398.293-.6.072-.153.143-.34.302-.413z",
    fill: "white"
  }));
});
SvgInk.displayName = "SvgInk";
SvgInk.defaultProps = {
  size: 24,
  color: "#DF1A14"
};
export default SvgInk;